import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
  defer
} from "react-router-dom";


import { LoginPage } from "./pages/Login";
import Register from "./pages/Register";
import PasswordReset from "./pages/PasswordReset";
import PasswordResetSuccess from "./pages/PasswordResetSuccess";
import EmailVerifySuccess from "./pages/EmailVerifySuccess";

import { HomePage } from "./pages/Home";
import { ProfilePage } from "./pages/Profile";
import { WelcomePage } from "./pages/Welcome";

// import SearchMeta from "./pages/SearchMeta"; // Elastic App Search — disabled
import SearchTypesense from "./pages/SearchTypesense";

import SearchAI from "./pages/SearchAI";

import SearchVlbApi from "./pages/SearchVlbApi";
import SearchLibriApi from "./pages/SearchLibriApi";


// import SearchPageLibri from "./pages/SearchLibri";
// import SearchPageMagazines from "./pages/SearchMagazines";

import OrderStatus from "./pages/OrderStatus";

import { Cart } from "./pages/Cart";
import { WishList } from "./pages/WishList";
import { Contact } from "./pages/Contact";
import { Abonnements } from "./pages/Abonnements";
import { OrderService } from "./pages/OrderService";

import { ProtectedLayout } from "./components/ProtectedLayout";
import { HomeLayout } from "./components/HomeLayout";
import { AuthLayout } from "./components/AuthLayout";
import { RoleProtectedRoute } from "./components/RoleProtectedRoute";

import { UserListPage } from "./pages/UserList";
import { UserPage } from "./pages/User";
import { ImprintPage } from "./pages/Imprint";
import { FAQPage } from "./pages/FAQ";
import { Rechnungsarchiv } from "./pages/Rechnungsarchiv";
import { DataImport } from "./pages/DataImport";
import EmailTemplates from "./pages/EmailTemplates";
import CartConfigurator from "./pages/CartConfigurator";
import { PunchoutPage } from "./pages/PunchoutPage";
import { PunchoutHelp } from "./pages/PunchoutHelp";
import { PunchoutClientManagement } from "./pages/PunchoutClientManagement";

import { auth } from "./firebase";

import "./styles.css";
// ideally this would be an API call to server to get logged in user data

const getUserData = () =>
  new Promise((resolve) => {

    setTimeout(() => {
      //const user = window.localStorage.getItem("user");
    }, 100)
    const user = auth.currentUser;
    resolve(user);
  }
  );

// for error
// const getUserData = () =>
//   new Promise((resolve, reject) =>
//     setTimeout(() => {
//       reject("Error");
//     }, 3000)
//   );

const ImprintPageExt = () => {
  window.location.href = 'https://brunswiker.de/impressum/';
  return null;
};

const ExternalPage = () => {

};

export const router = createBrowserRouter(

  createRoutesFromElements(
    <Route
      element={<AuthLayout />}
      loader={() => defer({ userPromise: getUserData() })}
    >

      <Route element={<HomeLayout />}>
        <Route path="/" element={<LoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/register" element={<Register />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/password-reset-success" element={<PasswordResetSuccess />} />
        <Route path="/email-verify-success" element={<EmailVerifySuccess />} />
      </Route>

      <Route path="/web" element={<ProtectedLayout />}>
        <Route index element={<WelcomePage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="welcome" element={<WelcomePage />} />
        <Route path="contact" element={<Contact />} />

        <Route path="user"  >
          <Route index element={<UserListPage />} />
          <Route path=":id" element={<UserPage />} />
        </Route>

        <Route path="searchvlbapi" element={<SearchVlbApi />} />
        <Route path="searchlibriapi" element={<SearchLibriApi />} />
        {/* Primary Meta-Suche is now powered by Typesense for all users (recommended path). */}
        <Route path="searchmeta" element={<SearchTypesense />} />
        {/* Legacy Elastic-based Meta-Suche ("alt") — disabled; see SearchMeta.js
        <Route path="meta-legacy" element={<SearchMeta />} />
        */}
        <Route path="searchai" element={<SearchAI />} />
        <Route path="orderstatus" element={
          <RoleProtectedRoute blockedRoles={['Buyer']} message="Buyer-Rolle hat keinen Zugriff auf Bestell-Status.">
            <OrderStatus />
          </RoleProtectedRoute>
        } />
        <Route path="orderservice" element={<OrderService />} />
        <Route path="rechnungsarchiv" element={
          <RoleProtectedRoute blockedRoles={['Buyer']} message="Buyer-Rolle hat keinen Zugriff auf Rechnungsarchiv.">
            <Rechnungsarchiv />
          </RoleProtectedRoute>
        } />
        <Route path="data-import" element={<DataImport />} />
        <Route path="email-templates" element={<EmailTemplates />} />
        <Route path="cart-configurator" element={<CartConfigurator />} />
        <Route path="punchout" element={<PunchoutPage />} />
        <Route path="punchout-help" element={<PunchoutHelp />} />
        <Route path="punchout-clients" element={<PunchoutClientManagement />} />

        <Route path="abonnements/*" element={
          <RoleProtectedRoute blockedRoles={['Buyer']} message="Buyer-Rolle hat keinen Zugriff auf Abo-Status.">
            <Abonnements />
          </RoleProtectedRoute>
        } >
          <Route path="abostatus" element={<Abonnements />} />
          {/* <Route path="abosearch" element={<Abonnements />} /> */}
          <Route path="aborequest" element={<Abonnements />} />

          <Route path="aboorder" element={<Abonnements />} />
          <Route path="abochange" element={<Abonnements />} />
          <Route path="abodelete" element={<Abonnements />} />
          <Route path="abocontact" element={<Abonnements />} />
          <Route path="aboexport" element={<Abonnements />} />
        </Route>

        <Route path="cart" element={<Cart />} />
        <Route path="wishlist" element={<WishList />} />
        <Route path="impressum" element={<ImprintPageExt />} />
        <Route path="faq" element={<FAQPage />} />

      </Route>
    </Route>
  )
);
